
<template>
	<div style="display: inline-block">
		<div class="bg" v-show="showOptions" @click="closeOptions"></div>
		<div class="universe-wrapper" >
			<div class="universe-button" @click="toggleOptions">Define Universe</div>
			<div class="options" :class="showOptionsList">
				<div class="inputWrapper">
					<div class="inputTitle">
						Asset class
						<span v-show="this.chosenSectors!==null" class="icon-rotate-cw" @click="clearSectors" v-tooltip="`clear chosen sectors`"></span>
					</div>
					<multiselect
						v-model="chosenSectors"
						:options="sectorList.orderNames"
						:multiple="true"
						:hideSelected="true"
						:showLabels="false"
						:searchable="false"
						:placeholder="`All Selected`"/>
				</div>
				<div class="inputWrapper">
					<div class="inputTitle">LCP due dilligence passed</div>
					<p-radio class="p-default p-round p-thick" color="info" :value="false" v-model="dueDilligence"  name="dueDilligence">
						All funds
					</p-radio>
					<p-radio class="p-default p-round p-thick" color="info" :value="true" v-model="dueDilligence" name="dueDilligence">
						LCP Operational Due Diligence passed
					</p-radio>
				</div>
				<div class="inputWrapper">
					<div class="inputTitle">LCP rating</div>
					<p-check class="p-default p-curve p-thick" color="info" v-model="lcpRating.buy">Buy</p-check>
					<p-check class="p-default p-curve p-thick" color="info" v-model="lcpRating.hold">Hold</p-check>
					<p-check class="p-default p-curve p-thick" color="info" v-model="lcpRating.review">Review</p-check>
					<p-check class="p-default p-curve p-thick" color="info" v-model="lcpRating.unrated">Unrated</p-check>
				</div>
				<div class="inputWrapper">
					<div class="inputTitle">Open to new money</div>
					<p-radio class="p-default p-round p-thick" color="info" :value="false" v-model="openFundsOnly" name="openFundsOnly">All funds</p-radio>
					<p-radio class="p-default p-round p-thick" color="info" :value="true" v-model="openFundsOnly" name="openFundsOnly">Open funds only</p-radio>
				</div>
				<div class="inputWrapper">
					<div class="inputTitle">Data source for static data</div>
					<p-radio class="p-default p-round p-thick" color="info" :value="true" v-model="allData" name="allData">All data</p-radio>
					<p-radio class="p-default p-round p-thick" color="info" :value="false" v-model="allData" name="allData">LCP data only</p-radio>
				</div>
				<div class="inputWrapper">
					<div class="btn btn-save" @click="updateUniverse">Apply filters to universe</div>
					<div class="fund-counter">Your universe: <span class="funds">{{universeData.data.length}} / <span class="muted">{{PensionsData.data.length}}</span></span></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import vOutsideEvents from 'vue-outside-events';

Vue.use(vOutsideEvents);
export default {
    name: 'defineUniverse',
    data () {
        return {
            showOptions: false,
            chosenSectors: [],
            dueDilligence: false,
            lcpRating: {
                buy: true,
                hold: true,
                review: true,
                unrated: true,
            },
			openFundsOnly: false,
			allData: true,
        };
    },
    created () {
        this.chosenSectors = this.$store.state.universe.chosenSectors.slice(0);
        this.dueDilligence = this.$store.state.universe.dueDilligence;
        this.lcpRating = Object.assign({}, this.$store.state.universe.lcpRating);
		this.openFundsOnly = this.$store.state.universe.openFundsOnly;
		this.allData = this.$store.state.universe.allData;
    },
    methods: {
        setDueDilligence (state) {
            this.dueDilligence = state;
        },
        toggleOptions () {
            this.showOptions = !this.showOptions;
        },
        closeOptions () {
            this.showOptions = false;
        },
        clearSectors () {
            this.chosenSectors = [];
        },
        updateUniverse () {
            this.$store.dispatch('universe/updateUniverse', this._data);
        },
    },
    computed: {
        PensionsData () {
            return this.$store.state.pensionsData;
        },
        universeData () {
            return this.$store.state.universe.data;
        },
        showOptionsList () {
            return this.showOptions ? 'show' : '';
        },
        colourSet () {
            const colList = this.$store.state.chart.colourSelection;
            const currentSet = this.$store.state.universe.data.categoryDimensions.findIndex(i => i.name === colList);
            return currentSet > -1 ? this.$store.state.universe.data.categoryDimensions[currentSet] : this.$store.state.universeData.categoryDimensions[0];
        },
        sectorList () {
            const categoryList = this.$store.state.universe.data.categoryFilter.find(element => element.categoryName === 'Asset class');
            return categoryList;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import 'src/assets/scss/all.scss';
.bg{
    position: absolute;
    top:0;
    left:0%;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.5);
    z-index: 4;
}
.universe-wrapper {
    display: inline-block;
    position: relative;
    vertical-align: middle;
    z-index: 5;
    .universe-button {
        background: $darkBlue;
        border-radius: 6px;
        color: white;
        cursor: pointer;
        padding: 6px 12px;
        text-align: center;
		margin-right: 5px;
    }

    .options {
        -moz-border-radius: 0.4167rem;
        -ms-border-radius: 0.4167rem;
        -o-border-radius: 0.4167rem;
        -webkit-border-radius: 0.4167rem;
        background-color: white;
        border-radius: 0.4167rem;
        border: 2px solid $darkBlue;
        box-shadow: 0 9px 23px rgba(0, 0, 0, 0.09), 0 5px 5px rgba(0, 0, 0, 0.06) !important;
        display: none;
        padding:20px;
        position: absolute;
        right: -220px;
        top:50px;
        width: 500px;
        z-index: 1;
        @include easeInOut(0.5s);
        &:after, &:before {
            border: solid transparent;
            bottom: 100%;
            content: " ";
            height: 0;
            pointer-events: none;
            position: absolute;
            width: 0;
        }
        &:after {
            border-bottom-color:#FFFFFF;
            border-color: transparent;
            border-width: 10px;
            margin-left: -10px;
            right: 221px;
        }
        &:before {
            border-bottom-color: $darkBlue;
            border-color: transparent;
            border-width: 16px;
            margin-left: -16px;
            right: 215px;
        }
        &.show {
            display: block;
        }
        .legendItem {
            float: left;
            margin-bottom: 20px;
            width:33%;
            .color {
                border-radius: 10px;
                float: left;
                height: 20px;
                margin-right: 10px;
                width: 20px;
            }
        }
        .inputWrapper{
            margin-top:15px;

            .multiselect{
                width: 100%;
            }
            &:first-child{
                margin-top:0;
            }

            .inputTitle {
                color: #002c5c;
                font-size: 14px;
                font-weight: 700;
                .icon-rotate-cw{
                    float:right;
                    cursor: pointer;
                }
            }
            .fund-counter{
                // display: inline-block;
                float: right;
                padding: 6px;
                .funds{
                    font-weight: bold;
                    color: $LCPBlue;
                    padding: 6px;
                    background: #f3f3f3;
                    border-radius: 6px;
                    .muted{
                        color:$darkGrey;
                    }
                }
            }
        }
    }
}
</style>
